__turbopack_context__.v({
  "content": "ShortnewsDetail-module-scss-module__750rvq__content",
  "header": "ShortnewsDetail-module-scss-module__750rvq__header",
  "homepageLink": "ShortnewsDetail-module-scss-module__750rvq__homepageLink",
  "player": "ShortnewsDetail-module-scss-module__750rvq__player",
  "sharer": "ShortnewsDetail-module-scss-module__750rvq__sharer",
  "shortnewsTitle": "ShortnewsDetail-module-scss-module__750rvq__shortnewsTitle",
  "source": "ShortnewsDetail-module-scss-module__750rvq__source",
  "title": "ShortnewsDetail-module-scss-module__750rvq__title",
  "titleSecondary": "ShortnewsDetail-module-scss-module__750rvq__titleSecondary",
});
